import React from 'react'
import { Form } from 'react-bootstrap'
import { Tooltip } from '../../../components/Tooltip/Tooltip'

export interface CRMUrlInputFieldProps {
  label: string
  tooltipText: string
  value: string | null
  onChange: (value: string) => void
  placeholder: string
  helperText: string
  disabled?: boolean
}

export const CRMUrlInputField: React.FC<CRMUrlInputFieldProps> = ({ label, tooltipText, value, onChange, placeholder, helperText, disabled = false }) => {
  return (
    <div>
      <label className='label-medium'>
        {label}&nbsp;
        <Tooltip className='zocks-text-gray-500' placement='right' title={tooltipText}>
          <i className='bi bi-info-circle' />
        </Tooltip>
      </label>
      <Form.Control className='mt-1' value={value || ''} onChange={(e) => onChange(e.currentTarget.value)} placeholder={placeholder} disabled={disabled} />
      <Form.Text className='text-muted'>{helperText}</Form.Text>
    </div>
  )
}
